import { Component, EventEmitter, Output } from '@angular/core';
import { isString } from '../../models/utils';
import { Endpoint, EntityType, MessageType, SearchType } from '../../models/enums';
import { View } from '../../models/view';
import { RestService } from '../../services/rest/rest.service';
import { GenericTreeNode } from '../generic-tree/generic-tree-node';
import { CommonService } from '../../services/common/common.service';

@Component({
    standalone: false,
    selector: 'res-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent {
    @Output() breadcrumbClicked = new EventEmitter<any>();
    breadcrumbs: Array<GenericTreeNode>;

    constructor(private restService: RestService, private commonService: CommonService) {
        this.breadcrumbs = new Array<GenericTreeNode>();
    }

    selectedTreeItemChanged(node: GenericTreeNode): void {
        this.breadcrumbs.length = 0;
        if (node) {
            if (node.data && isString(node.data.handle) && node.parent) {
                // child item

                if (node.entityType === EntityType.tagView || node.entityType === EntityType.custodian) {
                    this.breadcrumbs.splice(0, 0, node);
                    this.breadcrumbs.splice(0, 0, node.parent);
                    if (node.parent.parent) {
                        this.breadcrumbs.splice(0, 0, node.parent.parent);
                    }
                } else {
                    this.restService.post(Endpoint.viewManager_getViewBreadcrumbHistory, { handle: node.data.handle }).then(response => {
                        if (response && response.breadcrumbHistoryViewList) {
                            if (response.breadcrumbHistoryViewList.length > 0) {
                                // if it is an Export and is in transitView do not add additional export breadcrumbs
                                const isTransitView = response.breadcrumbHistoryViewList[0].attributes?.filter((attr) => attr.name === 'transientView');
                                if (isTransitView.length > 0 && response.breadcrumbHistoryViewList[0].viewType === 'EXPORT') {
                                    this.breadcrumbs = [];
                                }
                                response.breadcrumbHistoryViewList.forEach((element, index) => {
                                    const view = new View(element);
                                    if (view) {
                                        const viewName = (view.viewType && view.viewType.includes('_RESULT')) ? this.removeSearchPrefix(view.name) : view.name;
                                        const newNode = new GenericTreeNode({
                                            name: viewName,
                                            automationId: 'node-from-breadcrumb-' + view.viewType + '-' + viewName,
                                            data: view,
                                            parent: (node.data?.handle as string)?.includes(view.handle) ? node.parent : null
                                        });
                                        if (newNode.name === 'CaseData') {
                                            newNode.name = 'Project Data';
                                        } else if (newNode.name === 'discardpile') {
                                            newNode.name = 'Discard Pile';
                                        }
                                        const isBulkSearchParentNode = node.isArchivedNode() && node.data?.task === SearchType.BULK || node.data?.task === SearchType.METADATA_BULK;
                                        if (node.data?.handle === view.handle && isBulkSearchParentNode && view.name.startsWith('Bulk Search in ')) {
                                            this.commonService.sendMessage(MessageType.refreshBulkSearchParentNode, view);
                                        }
                                        const sampleAttrib = view.attributes ? view.attributes.find(a => a.name === 'sampleSetResult') : null;
                                        if (!((node.parent.entityType === EntityType.searchResult) &&
                                            (index === response.breadcrumbHistoryViewList.length - 1)) ||
                                            (node.entityType === EntityType.searchResult && sampleAttrib && sampleAttrib.value)) {
                                            this.breadcrumbs.splice(0, 0, newNode);
                                        }
                                    }
                                });
                            } else {
                                this.breadcrumbs.push(node);
                            }
                            this.breadcrumbs.splice(0, 0, node.parent);
                            if (node.parent.parent) {
                                this.breadcrumbs.splice(0, 0, node.parent.parent);
                            }
                        } else {
                            this.breadcrumbs.push(node.parent, node);
                        }
                    });
                }

            } else {
                if (node.parent) {
                    this.breadcrumbs.push(node.parent, node);
                } else {
                    this.breadcrumbs.push(node);
                }
            }
        }
    }

    getTitle(breadcrumb: GenericTreeNode): string {
        if (breadcrumb && breadcrumb.data) {
            if (breadcrumb.data.attributes && breadcrumb.data.attributes.length > 0) {
                const query = breadcrumb.data.attributes.filter(q => q.name === 'searchquery').pop();
                if (query) {
                    return query.value;
                }
            }
            return breadcrumb.name;
        }
        return null;
    }

    // for search results remove Searching prefix as per ECASL-27221
    removeSearchPrefix(name: string): string {
        if (name) {
            if (name.startsWith('Searching for ')) {
                name = name.replace('Searching for ', '');
            } else if (name.trim().startsWith('Searching ')) {
                name = name.trim().replace('Searching ', '');
            }
        }
        return name;
    }

    navigate(breadcrumb: GenericTreeNode): void {
        if (breadcrumb && this.breadcrumbClicked.observers.length > 0) {
            this.breadcrumbClicked.emit(breadcrumb);
        }
    }
}
